export const modules = [
  "Novosti",
  "Gradonačelnikov dnevnik",
  "Prijava kvarova",
  "Ankete",
  "Transparentnost",
  "Transport",
  "Parking",
  "Info servis",
];

export const partnerTypes = ["Premium Partner", "Standard"];

export const partnerStatuses = ["Inactive", "Active", "Upcoming"];
